// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-riding-gloves-for-naked-bike-racing-tourer-superbike-supersport-sps-3-unisex",
  "entries": [
    {
      "id": "33374588436670",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps3-full-finger-gallery-04.jpg?v=1783398048",
      "alt": "color:Black | Seibertron SPS-3 motorcycle riding gloves for BMX ATV MTB and road riding image 04"
    },
    {
      "id": "33374588698814",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps3-full-finger-gallery-12.jpg?v=1783398048",
      "alt": "color:Red | Seibertron SPS-3 motorcycle riding gloves for BMX ATV MTB and road riding image 12"
    }
  ],
  "variants": [
    {
      "id": "45277159719102",
      "title": "Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Black",
        "Adult S"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277159751870",
      "title": "Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Black",
        "Adult M"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277159784638",
      "title": "Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Black",
        "Adult L"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277159817406",
      "title": "Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Black",
        "Adult XL"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277159850174",
      "title": "Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXL"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277163028670",
      "title": "Black / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Black",
        "Youth XS"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277163061438",
      "title": "Black / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Black",
        "Youth S"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277163094206",
      "title": "Black / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Black",
        "Youth M"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277163126974",
      "title": "Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Black",
        "Youth L"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277163159742",
      "title": "Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Black",
        "Youth XL"
      ],
      "mediaId": "33450728816830"
    },
    {
      "id": "45277159882942",
      "title": "White / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "White",
        "Adult S"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277159915710",
      "title": "White / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "White",
        "Adult M"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277159948478",
      "title": "White / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "White",
        "Adult L"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277159981246",
      "title": "White / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "White",
        "Adult XL"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277160014014",
      "title": "White / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "White",
        "Adult XXL"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277163192510",
      "title": "White / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "White",
        "Youth XS"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277163225278",
      "title": "White / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "White",
        "Youth S"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277163258046",
      "title": "White / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "White",
        "Youth M"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277163290814",
      "title": "White / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "White",
        "Youth L"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277163323582",
      "title": "White / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "White",
        "Youth XL"
      ],
      "mediaId": "33450729046206"
    },
    {
      "id": "45277160046782",
      "title": "Red / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Red",
        "Adult S"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277160079550",
      "title": "Red / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Red",
        "Adult M"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277160112318",
      "title": "Red / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Red",
        "Adult L"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277160145086",
      "title": "Red / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Red",
        "Adult XL"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277160177854",
      "title": "Red / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXL"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277163356350",
      "title": "Red / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Red",
        "Youth XS"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277163389118",
      "title": "Red / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Red",
        "Youth S"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277163421886",
      "title": "Red / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Red",
        "Youth M"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277163454654",
      "title": "Red / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Red",
        "Youth L"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277163487422",
      "title": "Red / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Red",
        "Youth XL"
      ],
      "mediaId": "33450729242814"
    },
    {
      "id": "45277160210622",
      "title": "FL Yellow / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "FL Yellow",
        "Adult S"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277160243390",
      "title": "FL Yellow / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "FL Yellow",
        "Adult M"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277160276158",
      "title": "FL Yellow / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "FL Yellow",
        "Adult L"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277160308926",
      "title": "FL Yellow / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "FL Yellow",
        "Adult XL"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277160341694",
      "title": "FL Yellow / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "FL Yellow",
        "Adult XXL"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277163520190",
      "title": "FL Yellow / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "FL Yellow",
        "Youth XS"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277163552958",
      "title": "FL Yellow / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "FL Yellow",
        "Youth S"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277163585726",
      "title": "FL Yellow / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "FL Yellow",
        "Youth M"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277163618494",
      "title": "FL Yellow / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "FL Yellow",
        "Youth L"
      ],
      "mediaId": "33450729308350"
    },
    {
      "id": "45277163651262",
      "title": "FL Yellow / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "FL Yellow",
        "Youth XL"
      ],
      "mediaId": "33450729308350"
    }
  ],
  "singleVariant": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var mediaIds = config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
